import React, {useState} from 'react';

import {Button, Modal, Table} from "antd";
import api from "../../api";

export default function SubscribersModal() {

    const [subscribers, setSubscribers] = useState([])
    const [modalOpen, setModalOpen] = useState(false);

    const onOpen = () => {
        // Fetch subscribers from API or state management
        api.getCompanySubscribers().then(setSubscribers)
        setModalOpen(true);
    };

    return (
        <>
            <Modal
                width={800}
                title="Inschrijvingen"
                open={modalOpen}
                footer={null}
                onCancel={() => setModalOpen(false)}
            >
                <Table pagination={null} dataSource={subscribers} columns={[
                    {
                        title: 'Naam',
                        dataIndex: 'name',
                        key: 'name',
                    },
                    {
                        title: 'E-mail',
                        dataIndex: 'email',
                        key: 'email',
                    }
                ]}>

                </Table>
            </Modal>
            <Button type={"link"} className={"mar-r-1"} onClick={onOpen}>Inschrijvingen bekijken</Button>
        </>
    )
}